/**
 * Route for `creative-size-limit`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CreativeSizeLimitPage } from "../features/creative-size-limit/CreativeSizeLimitPage";

export const creativeSizeLimitRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/creative-size-limit",
	component: CreativeSizeLimitPage,
});

export default creativeSizeLimitRoute;
